import { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { useFetchGanttByIdQuery } from '@redux/api'

import { PageContext } from '@gantt/components/GanttCreateOrEdit'

export const useGanttConfiguration = () => {
  const { onSetCurrentConfiguration } = useContext(PageContext)
  const { code } = useParams()

  const [loading, setLoading] = useState(false)

  const { data, isLoading: isLoadingConfiguration } = useFetchGanttByIdQuery(code, {
    skip: !code,
    refetchOnMountOrArgChange: true,
  })

  useEffect(() => {
    if (data && code && !isLoadingConfiguration) {
      setLoading(true)
      data && onSetCurrentConfiguration(data)
    }
  }, [data])

  const handleSetLoading = (loadingState: boolean) => setLoading(loadingState)

  return {
    data,
    loading,
    handleSetLoading,
  }
}
